<template>
  <Container>
    <div class="ding-toolbar">
      <div class="ding-toolbar-left">
        <Input
          search
          clearable
          style="width:220px;"
          v-model="filter.search"
          placeholder="搜索流程名称 / processCode"
        />
        <Input
          clearable
          style="width:180px;"
          v-model="filter.userId"
          placeholder="指定用户可见（userId）"
          @on-enter="loadData"
        />
        <Button @click="loadData" :loading="loading">查询</Button>
      </div>
      <div class="ding-toolbar-right">
        <span class="ding-muted">共 {{ filteredData.length }} 个流程</span>
        <Button icon="md-refresh" :loading="loading" @click="loadData">刷新</Button>
      </div>
    </div>

    <div class="ding-table-wrap">
      <BaseTable
        :columns="columns"
        :data="pagedData"
        :loading="loading"
        :page="pagination.page"
        :pageSize="pagination.pageSize"
        :count="filteredData.length"
        border
        @on-page-change="(p) => pagination.page = p"
        @on-page-size-change="handlePageSizeChange"
      />
    </div>

    <Drawer v-model="detail.visible" title="流程信息" width="480">
      <div v-if="detail.data" class="ding-detail">
        <div class="ding-process-head">
          <img v-if="detail.data.iconUrl" :src="detail.data.iconUrl" class="ding-process-icon" />
          <div>
            <h2>{{ detail.data.name }}</h2>
            <p>{{ detail.data.processCode }}</p>
          </div>
        </div>
        <div class="ding-info-grid">
          <div class="ding-info-item"><label>目录</label><span>{{ detail.data.dirName || '-' }}</span></div>
          <div class="ding-info-item"><label>目录 ID</label><span>{{ detail.data.dirId || '-' }}</span></div>
          <div class="ding-info-item"><label>链接</label>
            <a v-if="detail.data.url" :href="detail.data.url" target="_blank">打开钉钉流程</a>
            <span v-else>-</span>
          </div>
        </div>
        <div class="ding-detail-footer">
          <Button type="primary" @click="goInstances(detail.data)">查看实例</Button>
          <Button style="margin-left:8px;" @click="detail.visible = false">关闭</Button>
        </div>
      </div>
    </Drawer>

    <BaseLoadingModal v-model="loading" title="正在加载审批流程..." />
  </Container>
</template>

<script>
import Container from '@/components/app/container.vue';

export default {
  name: 'DingProcesses',
  components: {Container},
  data() {
    return {
      loading: false,
      items: [],
      filter: {
        search: '',
        userId: '',
      },
      pagination: {
        page: 1,
        pageSize: 20,
      },
      detail: {
        visible: false,
        data: null,
      },
    };
  },
  computed: {
    filteredData() {
      const q = (this.filter.search || '').trim().toLowerCase();
      if (!q) return this.items;
      return this.items.filter((p) => {
        return String(p.name || '').toLowerCase().includes(q)
          || String(p.processCode || '').toLowerCase().includes(q)
          || String(p.dirName || '').toLowerCase().includes(q);
      });
    },
    pagedData() {
      const start = (this.pagination.page - 1) * this.pagination.pageSize;
      return this.filteredData.slice(start, start + this.pagination.pageSize);
    },
    columns() {
      return [{
        type: 'index',
        width: 60,
      }, {
        title: '图标',
        width: 70,
        align: 'center',
        render: (h, {row}) => {
          if (!row.iconUrl) return h('span', '-');
          return h('img', {
            attrs: {src: row.iconUrl},
            style: {width: '28px', height: '28px', borderRadius: '6px'},
          });
        },
      }, {
        title: '流程名称',
        key: 'name',
        minWidth: 160,
        render: (h, {row}) => h('a', {
          style: {color: 'var(--primary)', cursor: 'pointer'},
          on: {click: () => this.openDetail(row)},
        }, row.name || '-'),
      }, {
        title: 'processCode',
        key: 'processCode',
        minWidth: 220,
      }, {
        title: '目录',
        key: 'dirName',
        width: 120,
      }, {
        title: '操作',
        width: 200,
        fixed: 'right',
        render: (h, {row}) => h('div', {class: 'flex-wrap flex-center split5'}, [
          h('Button', {
            props: {size: 'small', type: 'primary'},
            on: {click: () => this.goInstances(row)},
          }, '实例'),
          h('Button', {
            props: {size: 'small'},
            on: {click: () => this.openDetail(row)},
          }, '详情'),
        ]),
      }];
    },
  },
  mounted() {
    this.$api.afterLogin(() => this.loadData());
  },
  methods: {
    unwrap(res) {
      return (res && res.data && res.data.data) || (res && res.data) || {};
    },
    handlePageSizeChange(size) {
      this.pagination.pageSize = size;
      this.pagination.page = 1;
    },
    async loadData() {
      this.loading = true;
      try {
        const params = ['all=1'];
        if (this.filter.userId) params.push(`userId=${encodeURIComponent(this.filter.userId)}`);
        const res = await this.$api.get(`/ding/processes?${params.join('&')}`);
        const data = this.unwrap(res);
        this.items = Array.isArray(data.list) ? data.list : [];
        this.pagination.page = 1;
      } catch (e) {
        this.Error(e);
      } finally {
        this.loading = false;
      }
    },
    openDetail(row) {
      this.detail.data = row;
      this.detail.visible = true;
    },
    goInstances(row) {
      const code = row.processCode || '';
      this.RouteTo(`instances?processCode=${encodeURIComponent(code)}`);
    },
  },
};
</script>

<style lang="less" scoped>
.ding-toolbar {
  flex-shrink: 0;
  box-sizing: border-box;
  min-height: 50px;
  padding: 8px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid var(--border);
  background: var(--bg);
}
.ding-toolbar-left,
.ding-toolbar-right {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}
.ding-muted {
  color: var(--text2);
  font-size: 12px;
}
.ding-table-wrap {
  flex: 1 1 0;
  min-height: 0;
  height: 0;
  overflow: hidden;
  position: relative;
}
.ding-process-head {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--border);
  h2 {
    margin: 0 0 4px;
    font-size: 18px;
  }
  p {
    margin: 0;
    color: var(--text2);
    font-size: 12px;
    word-break: break-all;
  }
}
.ding-process-icon {
  width: 48px;
  height: 48px;
  border-radius: 10px;
}
.ding-info-grid {
  display: grid;
  gap: 12px;
}
.ding-info-item {
  display: flex;
  label {
    width: 80px;
    color: var(--text2);
    flex-shrink: 0;
  }
}
.ding-detail-footer {
  margin-top: 24px;
  text-align: right;
}
</style>
